import { Component, EventEmitter, Output, QueryList, ViewChildren } from '@angular/core';
import { SortDirective } from '../types/sort.directive';
import { SortEvent } from '../types/sort.types';
import { TableListOptions } from '../types/table-list.types';
import { orderBy } from '../utils/Utils';


interface ItemFilter {
  [key: string]: string;
}
export interface FilterChange {
  $item?: ItemFilter | undefined;
  [key: string]: string | ItemFilter | undefined;
}

@Component({
  standalone: false,
  template: ''
})
export abstract class TableList<T> {
  data: T[] = [];
  defaultSortHeader: string;
  defaultDirection: string;
  fixedSize = 0;
  protected _tableListOptions: TableListOptions = {
    page: 0,
    size: 50,
    springSort: {},
    searchTerm: '',
    startDate: undefined,
    endDate: undefined,
  };

  @ViewChildren(SortDirective) headers: QueryList<SortDirective>;

  @Output() TableChange = new EventEmitter<TableListOptions>();
  @Output() FilterChange = new EventEmitter<FilterChange>();

  get page(): number {
    return this._tableListOptions.page || 0;
  }
  
  set page(page: number) {
    this._setTableListOptions({ page });
  }

  get size(): number {
    return this._fixedSize ||this._tableListOptions.size || 0;
  }

  set size(size: number) {
    this._setTableListOptions({ size });
  }

  get _fixedSize(): number {
    return this.fixedSize;
  }

  set _fixedSize(size: number) {
    this.fixedSize = size;
  }

  get searchTerm(): string {
    return this._tableListOptions.searchTerm || '';
  }

  set searchTerm(searchTerm: string) {
    this._setTableListOptions({ searchTerm });
  }

  get sort(): SortEvent | undefined {
    return this._tableListOptions.springSort;
  }

  set sort(springSort: SortEvent | undefined) {
    this._setTableListOptions({ springSort });
  }

  get startDate(): any {
    return this._tableListOptions.startDate;
  }

  set startDate(startDate: any) {
    this._setTableListOptions({ startDate });
  }

  get endDate(): any {
    return this._tableListOptions.endDate;
  }

  set endDate(endDate: any) {
    this._setTableListOptions({ endDate });
  }

  localSort(): void {
    const { sortName, column, direction }: any = this._tableListOptions.springSort;
    const sortCriteria = sortName !== '' && sortName !== undefined ? sortName : column;
    if (typeof sortCriteria !== 'undefined' && this.data.length) {
      this.data = orderBy(this.data, sortCriteria, direction);
    }
  }

  set tableOptions(tableOptions: TableListOptions) {
    this._setTableListOptions(tableOptions);
  }

  private _setTableListOptions(patch: Partial<TableListOptions>): void {
    Object.assign(this._tableListOptions, patch);
    this.TableChange.emit(this._tableListOptions);
    // only call local sort if there's no pagination
    if (!this._tableListOptions.page) {
      this.localSort();
    }
  }
}
